// extracted by mini-css-extract-plugin
export var disabled = "_k-a";
export var hierarchyLinkGray = "_k-4";
export var hierarchyLinkUnderline = "_k-3";
export var hierarchyPrimary = "_k-0";
export var hierarchySecondary = "_k-1";
export var hierarchyTertiary = "_k-2";
export var pressed = "_k-6";
export var themeAction = "_k-5";
export var themeDestructive = "_k-8";
export var themeNormal = "_k-7";
export var themeSuccess = "_k-9";